var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic_security",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#006dc9}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_24px_shape",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_lock_1075236_000000",
    transform: "translate(-17.439 -10.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10392",
    d: "M43.4 47.77a2.676 2.676 0 0 0-.828 5.221v2.4a.761.761 0 1 0 1.523 0v-2.363a2.675 2.675 0 0 0-.695-5.258zm0 3.831a1.154 1.154 0 1 1 1.154-1.154A1.155 1.155 0 0 1 43.4 51.6z",
    className: "cls-2",
    transform: "translate(-13.919 -26.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10393",
    d: "M23.4 17.328v1.444h-1.35a.761.761 0 0 0-.761.761V32.5a.761.761 0 0 0 .761.761h14.77a.761.761 0 0 0 .761-.761V19.533a.761.761 0 0 0-.761-.761h-1.464v-1.444a5.977 5.977 0 1 0-11.953 0zm12.661 14.408H22.815V20.295h1.2a.7.7 0 0 0 .146.014.789.789 0 0 0 .146-.014H34.45a.7.7 0 0 0 .146.014.789.789 0 0 0 .146-.014h1.319zm-2.227-14.408v1.444h-8.907v-1.444a4.454 4.454 0 1 1 8.907 0z",
    className: "cls-2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0267e7c550097d7b6ad0c509b77b5c06.svg";
export { ForwardRef as ReactComponent };